import ApplicationLogo from '@/Components/ApplicationLogo';
import { Separator } from '@/Components/ui/separator';
import { formatMobileNumber } from '@/lib/utils';
import { Link, usePage } from '@inertiajs/react';

export default function Guest({ children, }) {
   const { supportEmail, supportPhone } = usePage().props
   return (
      <div className="min-h-screen flex grow bg-slate-50 dark:bg-navy-900">
         {/* <div className='fixed top-0 hidden p-6 lg:block lg:px-12'>
            <a href="/" className='flex items-center space-x-2'>
               <ApplicationLogo className="w-20 h-20 fill-current text-gray-500" />
            </a>
         </div> */}
         <div className="hidden w-full place-items-center lg:grid">
            <div className="w-full h-full">
               <picture>
                  <img src="/img/bsc-banner-lg.jpg" alt="BSC" className="w-full h-full object-cover" />
               </picture>
            </div>
         </div>

         <main className="flex w-full flex-col items-center bg-white dark:bg-navy-700 lg:max-w-md">
            <div className='md:pt-6'>
                  <a href="/" className='flex items-center space-x-2'>
                  <ApplicationLogo className="w-20 h-20 fill-current text-gray-500" />
               </a>
            </div>
            <div className='flex w-full max-w-sm grow flex-col justify-center p-5'>
               {children}
            </div>
            <div className='text-center'>
               <p className='text-sm mb-3 text-slate-600'>
                  Having trouble in signin or registration, contact admin <br />
                  <div className="flex justify-center gap-4 mt-1">
                     <a href={"mailto:"+supportEmail}>{supportEmail}</a>
                     {'|'}
                     <a href={"mailto:"+supportPhone}>{formatMobileNumber(supportPhone)}</a>
                  </div>
               </p>
               {/* <div className="mt-5 mb-3 flex justify-center text-xs text-slate-600 dark:text-navy-300">
                  <a href="#">Privacy Notice</a>
                  <div className="mx-3 my-1 w-px bg-slate-200 dark:bg-navy-500"></div>
                  <a href="#">Term of service</a>
               </div> */}
               <div className="links mb-3 text-xs text-slate-600 dark:text-navy-300">
                  <Link href={route('rules_and_regulations')}>Rules & Regulations</Link>
               </div>
            </div>
         </main>
      </div>
   );
}
